import React from "react";
import { Redirect } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import useEspaceActif, { ESPACES } from "../../hooks/useEspaceActif/useEspaceActif";

// Routes réservées à l'espace entreprise : en espace particulier, l'accès
// direct par URL redirige vers l'accueil (PER-2207).
const PrivateRouteEntreprise = (props) => {
  const { espace } = useEspaceActif();

  if (espace === ESPACES.PARTICULIER) return <Redirect to="/accueil" />;
  return <PrivateRoute {...props} />;
};

export default PrivateRouteEntreprise;
